
import * as api from "../constant/NewAPI";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Utils from "../constant/Utils";
import Swal from "sweetalert2";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";

// import * as api from "../constant/API";

const AcademicCcSkills = () => {

    const roleId = localStorage.getItem("RoleId");

    const [searchInput, setSearchInput] = useState("");
    const [skillsList, setSkillsList] = useState([]);
    const [skillTitle, setSkillTitle] = useState("");
    const [skillOrder, setSkillOrder] = useState("");
    const [skillDescription, setSkillDescription] = useState("");
    const [skillId, setSkillId] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const formRef = useRef(null);

    // if (roleId === "1") {
    useEffect(() => {
        ccskillList()
    }, [])
    // }

    function ccskillList() {
        const getCcSkillList = api.adminCcSkillsList;
        fetch(getCcSkillList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                // console.log(result.data)
                setSkillsList(result.data);
            })
            .catch((error) => {
                console.log("Failed to fetch grade list", error);
            })
    }

    const filteredData = skillsList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value.toString().toLowerCase()
        );
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editGrade(rowData)}>
                <i className="feather-edit" />
                Edit
            </Link>
        );
    };

    const slNoRender = (rowData) => {
        return <span>{rowData.ccSkillId}</span>;
    };

    const nameRender = (rowData) => {
        return <span>{rowData.ccSkillName}</span>;
    };

    const descriptionRender = (rowData) => {
        return <span>{rowData.ccSkillDescription}</span>
    };

    const orderRender = (rowData) => {
        return <span>{rowData.ccSkillOrderBy}</span>
    }

    function newCcSkill() {
        setOpenModal(true)
        setIsEdit(false)
        setSkillTitle("");
        setSkillDescription("");
        setSkillOrder("")
    }

    function editGrade(selectedRow) {
        const sklId = selectedRow.ccSkillId;
        const getSkillDetails = api.adminCcSkillsData + '/' + sklId//"?ccSkillId="+sklId;
        fetch(getSkillDetails, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((skillResponse) => skillResponse.json())
            .then((skillResult) => {
                // console.log(skillResult)
                // const dta = skillResult.data[0];
                const dta = skillResult.data;
                setSkillId(dta.ccSkillId)
                setSkillTitle(dta.ccSkillName)
                setSkillDescription(dta.ccSkillDescription)
                setSkillOrder(dta.ccSkillOrderBy)
                setIsEdit(true)
                setOpenModal(true)
            })
            .catch((error) => {
                console.log("Failed to fetch selected row details.", error);
            })

    }
    function addCcSkill(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateCcSkill()
            } else {
                const formData = new FormData();
                formData.append('ccSkillId', skillId);
                formData.append('ccSkillName', skillTitle);
                formData.append('ccskillorderby', skillOrder);
                formData.append('ccskillDescription', skillDescription);

                const skillAdd = api.adminCcSkillsCreate;
                fetch(skillAdd, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        } else {
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        }
                    })
            }
            setOpenModal(false)
        }
    }

    function updateCcSkill() {
        const formData = new FormData();
        formData.append('ccSkillId', skillId);
        formData.append('ccSkillNameEdit', skillTitle);
        formData.append('ccSkillOrderByEdit', skillOrder);
        formData.append('ccSkillDescriptionEdit', skillDescription);

        const skillUpdate = api.adminCcSkillsUpdate;
        fetch(skillUpdate, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((updateResponse) => updateResponse.json())
            .then((updateResult) => {
                if (updateResult.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: updateResult.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: updateResult.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
            .catch((error) => {
                console.log("Failed to update the cc skill", error)
            })
    }

    return (
        <>
            <div className="row">
                <div className="col-sm-12">
                    <div className="court-tab-content">
                        <div className="card card-tableset">
                            <div className="card-body">
                                <div className="coache-head-blk">
                                    <div className="row align-items-center">
                                        {roleId == 1 ? (
                                            <>
                                                <div className="row col-lg-12">
                                                    <div className="col-lg-4">
                                                        <Link
                                                            to="#"
                                                            className="btn btn-secondary"
                                                            onClick={newCcSkill}>
                                                            <i className="feather-plus" />&nbsp;
                                                            Add Cc Skill
                                                        </Link>
                                                    </div>
                                                </div>
                                            </>
                                        ) : null}
                                        <div className="col-md-6">
                                        </div>
                                        <div className="col-md-6">
                                            <div className="dataTables_filter">
                                                <label>
                                                    <input
                                                        type="text"
                                                        value={searchInput}
                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                        placeholder="Search"
                                                        className="form-control"
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50]}
                                                currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            >
                                                <Column
                                                    sortable
                                                    field="ccSkillId"
                                                    body={slNoRender}
                                                    header="Sl No"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    field="ccSkillName"
                                                    body={nameRender}
                                                    header="CC Skill Name"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    field="ccSkillDescription"
                                                    body={descriptionRender}
                                                    header="CC Skill Description"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    field="ccSkillOrderBy"
                                                    body={orderRender}
                                                    header="CC Skill Order Type"
                                                ></Column>
                                                <Column
                                                    body={editDetails}
                                                ></Column>
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add/ Edit Grade */}
            <Modal
                show={openModal}
                size="md"
                centered
            >
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case"><i className="feather-plus" />{isEdit ? "Edit " : "Add "}Cc Skill</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="col-lg-12">
                            <div className="input-space">
                                <label className="form-label">CC Skill Title</label>
                                <input
                                    id="ccSkillName"
                                    className="form-control"
                                    style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                    value={skillTitle}
                                    required
                                    onChange={(e) => {
                                        setSkillTitle(e.target.value)
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="input-space">
                                <label className="form-label">CC Skill Description</label>
                                <textarea
                                    id="assessmentDescription"
                                    className="form-control"
                                    style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                    value={skillDescription}
                                    required
                                    onChange={(e) => {
                                        setSkillDescription(e.target.value)
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="input-space">
                                <label className="form-label">CC Skill Order</label>
                                <input
                                    type="number"
                                    id="ccSkillOrderBy"
                                    className="form-control"
                                    style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                    value={skillOrder}
                                    required
                                    onChange={(e) => {
                                        setSkillOrder(e.target.value)
                                    }}
                                />
                            </div>
                        </div>
                        <ModalFooter>
                            <Button
                                className="btn-primary text-uppercase"
                                variant="success"
                                type="submit"
                                onClick={addCcSkill}
                                data-bs-dismiss="modal" aria-label="Close"
                            >
                                <b><i className="fas fa-save" />{isEdit ? "Update" : "Save"}</b>
                            </Button>
                        </ModalFooter>
                    </form>
                </ModalBody>
            </Modal>
            {/* /Add/ Edit Schedule */}
        </>
    );
};

export default AcademicCcSkills;